var _path, _rect, _circle, _g, _rect2, _rect3, _rect4, _path2, _path3, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTips3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 431,
    height: 399,
    viewBox: "0 0 431 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H404C418.912 0 431 12.0883 431 27V372C431 386.912 418.912 399 404 399H52C37.6406 399 26 387.359 26 373V0Z",
    fill: "#FFF5F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 283.05,
    width: 92,
    height: 87,
    rx: 11,
    transform: "rotate(-44.9964 0 283.05)",
    fill: "#FFEBEB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 302,
    cy: 79,
    r: 35,
    fill: "#FFEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3024)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 94,
    width: 333,
    height: 202,
    rx: 9,
    fill: "#EBF9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 190.25H268C271.728 190.25 274.75 193.272 274.75 197V295.75H62.25V197C62.25 193.272 65.2721 190.25 69 190.25Z",
    fill: "#F5FEFF",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.25,
    y: 206.25,
    width: 212.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 216,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 213,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 211,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 211,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 211,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 211,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 213,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 216,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 219,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.25,
    y: 227.25,
    width: 212.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 237,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 234,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 232,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 232,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 232,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 232,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 234,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 237,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 240,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.25,
    y: 248.25,
    width: 212.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 258,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 255,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 253,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 253,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 253,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 253,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 255,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 258,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 261,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.25,
    y: 269.25,
    width: 212.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 279,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 276,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 274,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 274,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 274,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 274,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 276,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 279,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 282,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.25,
    y: 290.25,
    width: 212.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 300,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 295,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 295,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 295,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 295,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.25,
    y: 121.25,
    width: 75.5,
    height: 43.5,
    rx: 4.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.25,
    y: 121.25,
    width: 128.5,
    height: 43.5,
    rx: 4.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.25,
    y: 121.25,
    width: 128.5,
    height: 173.5,
    rx: 4.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 179,
    width: 16,
    height: 4,
    rx: 1,
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 179,
    width: 16,
    height: 4,
    rx: 1,
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.25,
    y: 171.25,
    width: 57.5,
    height: 15.5,
    rx: 4.75,
    fill: "white",
    stroke: "#FC563A",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.959 180.425H183.611L182.918 182H181.991L184.844 175.7H185.735L188.597 182H187.652L186.959 180.425ZM186.644 179.705L185.285 176.618L183.926 179.705H186.644ZM193.867 175.322V182H193.039V181.244C192.847 181.508 192.604 181.709 192.31 181.847C192.016 181.985 191.692 182.054 191.338 182.054C190.876 182.054 190.462 181.952 190.096 181.748C189.73 181.544 189.442 181.259 189.232 180.893C189.028 180.521 188.926 180.095 188.926 179.615C188.926 179.135 189.028 178.712 189.232 178.346C189.442 177.98 189.73 177.695 190.096 177.491C190.462 177.287 190.876 177.185 191.338 177.185C191.68 177.185 191.995 177.251 192.283 177.383C192.571 177.509 192.811 177.698 193.003 177.95V175.322H193.867ZM191.41 181.298C191.71 181.298 191.983 181.229 192.229 181.091C192.475 180.947 192.667 180.749 192.805 180.497C192.943 180.239 193.012 179.945 193.012 179.615C193.012 179.285 192.943 178.994 192.805 178.742C192.667 178.484 192.475 178.286 192.229 178.148C191.983 178.01 191.71 177.941 191.41 177.941C191.104 177.941 190.828 178.01 190.582 178.148C190.342 178.286 190.15 178.484 190.006 178.742C189.868 178.994 189.799 179.285 189.799 179.615C189.799 179.945 189.868 180.239 190.006 180.497C190.15 180.749 190.342 180.947 190.582 181.091C190.828 181.229 191.104 181.298 191.41 181.298ZM200.002 175.322V182H199.174V181.244C198.982 181.508 198.739 181.709 198.445 181.847C198.151 181.985 197.827 182.054 197.473 182.054C197.011 182.054 196.597 181.952 196.231 181.748C195.865 181.544 195.577 181.259 195.367 180.893C195.163 180.521 195.061 180.095 195.061 179.615C195.061 179.135 195.163 178.712 195.367 178.346C195.577 177.98 195.865 177.695 196.231 177.491C196.597 177.287 197.011 177.185 197.473 177.185C197.815 177.185 198.13 177.251 198.418 177.383C198.706 177.509 198.946 177.698 199.138 177.95V175.322H200.002ZM197.545 181.298C197.845 181.298 198.118 181.229 198.364 181.091C198.61 180.947 198.802 180.749 198.94 180.497C199.078 180.239 199.147 179.945 199.147 179.615C199.147 179.285 199.078 178.994 198.94 178.742C198.802 178.484 198.61 178.286 198.364 178.148C198.118 178.01 197.845 177.941 197.545 177.941C197.239 177.941 196.963 178.01 196.717 178.148C196.477 178.286 196.285 178.484 196.141 178.742C196.003 178.994 195.934 179.285 195.934 179.615C195.934 179.945 196.003 180.239 196.141 180.497C196.285 180.749 196.477 180.947 196.717 181.091C196.963 181.229 197.239 181.298 197.545 181.298ZM208.553 177.23V183.746H207.689V181.28C207.491 181.532 207.248 181.724 206.96 181.856C206.678 181.988 206.366 182.054 206.024 182.054C205.562 182.054 205.148 181.952 204.782 181.748C204.416 181.544 204.128 181.259 203.918 180.893C203.714 180.521 203.612 180.095 203.612 179.615C203.612 179.135 203.714 178.712 203.918 178.346C204.128 177.98 204.416 177.695 204.782 177.491C205.148 177.287 205.562 177.185 206.024 177.185C206.378 177.185 206.702 177.254 206.996 177.392C207.29 177.524 207.533 177.722 207.725 177.986V177.23H208.553ZM206.096 181.298C206.396 181.298 206.669 181.229 206.915 181.091C207.161 180.947 207.353 180.749 207.491 180.497C207.629 180.239 207.698 179.945 207.698 179.615C207.698 179.285 207.626 178.994 207.482 178.742C207.344 178.49 207.152 178.295 206.906 178.157C206.666 178.013 206.396 177.941 206.096 177.941C205.79 177.941 205.514 178.01 205.268 178.148C205.028 178.286 204.836 178.484 204.692 178.742C204.554 178.994 204.485 179.285 204.485 179.615C204.485 179.945 204.554 180.239 204.692 180.497C204.836 180.749 205.028 180.947 205.268 181.091C205.514 181.229 205.79 181.298 206.096 181.298ZM214.634 177.23V182H213.815V181.28C213.641 181.526 213.41 181.718 213.122 181.856C212.84 181.988 212.531 182.054 212.195 182.054C211.559 182.054 211.058 181.88 210.692 181.532C210.326 181.178 210.143 180.659 210.143 179.975V177.23H211.007V179.876C211.007 180.338 211.118 180.689 211.34 180.929C211.562 181.163 211.88 181.28 212.294 181.28C212.75 181.28 213.11 181.142 213.374 180.866C213.638 180.59 213.77 180.2 213.77 179.696V177.23H214.634ZM220.59 179.642C220.59 179.708 220.584 179.795 220.572 179.903H216.702C216.756 180.323 216.939 180.662 217.251 180.92C217.569 181.172 217.962 181.298 218.43 181.298C219 181.298 219.459 181.106 219.807 180.722L220.284 181.28C220.068 181.532 219.798 181.724 219.474 181.856C219.156 181.988 218.799 182.054 218.403 182.054C217.899 182.054 217.452 181.952 217.062 181.748C216.672 181.538 216.369 181.247 216.153 180.875C215.943 180.503 215.838 180.083 215.838 179.615C215.838 179.153 215.94 178.736 216.144 178.364C216.354 177.992 216.639 177.704 216.999 177.5C217.365 177.29 217.776 177.185 218.232 177.185C218.688 177.185 219.093 177.29 219.447 177.5C219.807 177.704 220.086 177.992 220.284 178.364C220.488 178.736 220.59 179.162 220.59 179.642ZM218.232 177.914C217.818 177.914 217.47 178.04 217.188 178.292C216.912 178.544 216.75 178.874 216.702 179.282H219.762C219.714 178.88 219.549 178.553 219.267 178.301C218.991 178.043 218.646 177.914 218.232 177.914ZM226.236 177.23V182H225.417V181.28C225.243 181.526 225.012 181.718 224.724 181.856C224.442 181.988 224.133 182.054 223.797 182.054C223.161 182.054 222.66 181.88 222.294 181.532C221.928 181.178 221.745 180.659 221.745 179.975V177.23H222.609V179.876C222.609 180.338 222.72 180.689 222.942 180.929C223.164 181.163 223.482 181.28 223.896 181.28C224.352 181.28 224.712 181.142 224.976 180.866C225.24 180.59 225.372 180.2 225.372 179.696V177.23H226.236ZM232.192 179.642C232.192 179.708 232.186 179.795 232.174 179.903H228.304C228.358 180.323 228.541 180.662 228.853 180.92C229.171 181.172 229.564 181.298 230.032 181.298C230.602 181.298 231.061 181.106 231.409 180.722L231.886 181.28C231.67 181.532 231.4 181.724 231.076 181.856C230.758 181.988 230.401 182.054 230.005 182.054C229.501 182.054 229.054 181.952 228.664 181.748C228.274 181.538 227.971 181.247 227.755 180.875C227.545 180.503 227.44 180.083 227.44 179.615C227.44 179.153 227.542 178.736 227.746 178.364C227.956 177.992 228.241 177.704 228.601 177.5C228.967 177.29 229.378 177.185 229.834 177.185C230.29 177.185 230.695 177.29 231.049 177.5C231.409 177.704 231.688 177.992 231.886 178.364C232.09 178.736 232.192 179.162 232.192 179.642ZM229.834 177.914C229.42 177.914 229.072 178.04 228.79 178.292C228.514 178.544 228.352 178.874 228.304 179.282H231.364C231.316 178.88 231.151 178.553 230.869 178.301C230.593 178.043 230.248 177.914 229.834 177.914Z",
    fill: "#FC563A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.949 167.684C232.865 167.433 232.685 167.224 232.447 167.106C232.21 166.987 231.936 166.967 231.684 167.051C231.432 167.135 231.224 167.315 231.105 167.553C230.987 167.79 230.967 168.065 231.051 168.316L232.051 171.316C232.135 171.568 232.315 171.776 232.552 171.895C232.79 172.013 233.064 172.033 233.316 171.949C233.568 171.865 233.776 171.685 233.894 171.448C234.013 171.211 234.033 170.936 233.949 170.684L232.949 167.684ZM239.707 170.707C239.889 170.519 239.99 170.266 239.988 170.004C239.985 169.742 239.88 169.491 239.695 169.305C239.509 169.12 239.258 169.015 238.996 169.013C238.734 169.01 238.481 169.111 238.293 169.293L236.293 171.293C236.111 171.482 236.01 171.734 236.012 171.997C236.014 172.259 236.12 172.51 236.305 172.695C236.49 172.88 236.741 172.986 237.003 172.988C237.266 172.99 237.518 172.889 237.707 172.707L239.707 170.707ZM227.317 172.051C227.065 171.967 226.79 171.987 226.553 172.105C226.316 172.224 226.135 172.432 226.051 172.684C225.967 172.935 225.987 173.21 226.106 173.447C226.224 173.685 226.432 173.865 226.684 173.949L229.684 174.949C229.936 175.033 230.21 175.013 230.447 174.895C230.685 174.776 230.865 174.568 230.949 174.316C231.033 174.065 231.013 173.79 230.894 173.553C230.776 173.315 230.568 173.135 230.316 173.051L227.317 172.051ZM234.342 174.061C234.163 173.996 233.97 173.984 233.784 174.025C233.598 174.066 233.428 174.159 233.294 174.293C233.159 174.428 233.066 174.598 233.024 174.783C232.983 174.969 232.995 175.162 233.06 175.341L237.06 186.341C237.129 186.532 237.255 186.696 237.419 186.814C237.584 186.931 237.781 186.996 237.984 186.999C238.186 187.002 238.385 186.944 238.553 186.832C238.722 186.72 238.853 186.559 238.928 186.371L240.365 182.78L244.293 186.707C244.385 186.803 244.495 186.879 244.617 186.931C244.739 186.984 244.871 187.011 245.003 187.012C245.136 187.014 245.268 186.988 245.391 186.938C245.514 186.888 245.625 186.814 245.719 186.72C245.813 186.626 245.887 186.514 245.938 186.391C245.988 186.268 246.013 186.137 246.012 186.004C246.011 185.871 245.983 185.74 245.931 185.618C245.879 185.496 245.802 185.385 245.707 185.293L241.779 181.365L245.371 179.929C245.559 179.854 245.72 179.723 245.833 179.555C245.945 179.386 246.003 179.187 246 178.984C245.997 178.782 245.932 178.585 245.814 178.42C245.697 178.255 245.532 178.129 245.341 178.06L234.341 174.06L234.342 174.061ZM231.707 178.707C231.802 178.615 231.879 178.505 231.931 178.383C231.983 178.261 232.011 178.129 232.012 177.997C232.013 177.864 231.988 177.732 231.938 177.609C231.887 177.486 231.813 177.375 231.719 177.281C231.625 177.187 231.514 177.113 231.391 177.062C231.268 177.012 231.136 176.987 231.003 176.988C230.871 176.989 230.739 177.017 230.617 177.069C230.495 177.122 230.385 177.198 230.293 177.293L228.293 179.293C228.197 179.385 228.121 179.496 228.069 179.618C228.016 179.74 227.989 179.871 227.988 180.004C227.986 180.137 228.012 180.268 228.062 180.391C228.112 180.514 228.187 180.626 228.28 180.72C228.374 180.814 228.486 180.888 228.609 180.938C228.732 180.988 228.864 181.014 228.996 181.012C229.129 181.011 229.26 180.984 229.382 180.931C229.504 180.879 229.615 180.803 229.707 180.707L231.707 178.707Z",
    fill: "#FC563A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 129,
    width: 51,
    height: 5,
    rx: 2.5,
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.25,
    y: 176.25,
    width: 35.5,
    height: 9.5,
    rx: 4.75,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.25,
    y: 94.25,
    width: 332.5,
    height: 201.5,
    rx: 8.75,
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 293.25,
    y: 144.25,
    width: 103.5,
    height: 50.5,
    rx: 4.75,
    fill: "#FEFDFD",
    stroke: "#DCDCDC",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 177,
    width: 25,
    height: 14,
    rx: 5,
    fill: "#FC563A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M303.163 186.056C302.794 186.056 302.437 186 302.092 185.888C301.751 185.771 301.483 185.622 301.287 185.44L301.546 184.894C301.733 185.062 301.971 185.2 302.26 185.307C302.554 185.41 302.855 185.461 303.163 185.461C303.569 185.461 303.872 185.393 304.073 185.258C304.274 185.118 304.374 184.934 304.374 184.705C304.374 184.537 304.318 184.402 304.206 184.299C304.099 184.192 303.963 184.11 303.8 184.054C303.641 183.998 303.415 183.935 303.121 183.865C302.752 183.776 302.454 183.688 302.225 183.599C302.001 183.51 301.807 183.375 301.644 183.193C301.485 183.006 301.406 182.757 301.406 182.444C301.406 182.183 301.474 181.947 301.609 181.737C301.749 181.527 301.959 181.359 302.239 181.233C302.519 181.107 302.867 181.044 303.282 181.044C303.571 181.044 303.856 181.081 304.136 181.156C304.416 181.231 304.656 181.338 304.857 181.478L304.626 182.038C304.421 181.907 304.201 181.809 303.968 181.744C303.735 181.674 303.506 181.639 303.282 181.639C302.885 181.639 302.587 181.711 302.386 181.856C302.19 182.001 302.092 182.187 302.092 182.416C302.092 182.584 302.148 182.722 302.26 182.829C302.372 182.932 302.51 183.013 302.673 183.074C302.841 183.13 303.067 183.191 303.352 183.256C303.721 183.345 304.017 183.433 304.241 183.522C304.465 183.611 304.656 183.746 304.815 183.928C304.978 184.11 305.06 184.355 305.06 184.663C305.06 184.92 304.99 185.155 304.85 185.37C304.71 185.58 304.498 185.748 304.213 185.874C303.928 185.995 303.578 186.056 303.163 186.056ZM307.336 182.255C307.849 182.255 308.241 182.381 308.512 182.633C308.787 182.885 308.925 183.261 308.925 183.76V186H308.288V185.51C308.176 185.683 308.015 185.816 307.805 185.909C307.599 185.998 307.354 186.042 307.07 186.042C306.654 186.042 306.321 185.942 306.069 185.741C305.821 185.54 305.698 185.277 305.698 184.95C305.698 184.623 305.817 184.362 306.055 184.166C306.293 183.965 306.671 183.865 307.189 183.865H308.253V183.732C308.253 183.443 308.169 183.221 308.001 183.067C307.833 182.913 307.585 182.836 307.259 182.836C307.039 182.836 306.825 182.873 306.615 182.948C306.405 183.018 306.227 183.114 306.083 183.235L305.803 182.731C305.994 182.577 306.223 182.46 306.489 182.381C306.755 182.297 307.037 182.255 307.336 182.255ZM307.182 185.524C307.438 185.524 307.66 185.468 307.847 185.356C308.033 185.239 308.169 185.076 308.253 184.866V184.348H307.217C306.647 184.348 306.363 184.539 306.363 184.922C306.363 185.109 306.435 185.256 306.58 185.363C306.724 185.47 306.925 185.524 307.182 185.524ZM313.383 182.29L311.759 186H311.073L309.449 182.29H310.149L311.423 185.265L312.725 182.29H313.383ZM317.261 184.166C317.261 184.217 317.256 184.285 317.247 184.369H314.237C314.279 184.696 314.421 184.959 314.664 185.16C314.911 185.356 315.217 185.454 315.581 185.454C316.024 185.454 316.381 185.305 316.652 185.006L317.023 185.44C316.855 185.636 316.645 185.785 316.393 185.888C316.145 185.991 315.868 186.042 315.56 186.042C315.168 186.042 314.82 185.963 314.517 185.804C314.213 185.641 313.978 185.414 313.81 185.125C313.646 184.836 313.565 184.509 313.565 184.145C313.565 183.786 313.644 183.461 313.803 183.172C313.966 182.883 314.188 182.659 314.468 182.5C314.752 182.337 315.072 182.255 315.427 182.255C315.781 182.255 316.096 182.337 316.372 182.5C316.652 182.659 316.869 182.883 317.023 183.172C317.181 183.461 317.261 183.793 317.261 184.166ZM315.427 182.822C315.105 182.822 314.834 182.92 314.615 183.116C314.4 183.312 314.274 183.569 314.237 183.886H316.617C316.579 183.573 316.451 183.319 316.232 183.123C316.017 182.922 315.749 182.822 315.427 182.822Z",
    fill: "#FEFDFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94.25H375C379.832 94.25 383.75 98.1675 383.75 103V113.75H51.25V103C51.25 98.1675 55.1675 94.25 60 94.25Z",
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 75,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 75,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 75,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 91,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 91,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 151,
    width: 29,
    height: 8,
    rx: 1,
    fill: "#E2E2E2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 163,
    width: 29,
    height: 8,
    rx: 1,
    fill: "#E2E2E2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 331,
    y: 151,
    width: 28,
    height: 8,
    rx: 1,
    fill: "#E2E2E2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 331,
    y: 163,
    width: 28,
    height: 8,
    rx: 1,
    fill: "#E2E2E2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 151,
    width: 29,
    height: 8,
    rx: 1,
    fill: "#E2E2E2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 163,
    width: 29,
    height: 8,
    rx: 1,
    fill: "#E2E2E2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3024"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 94,
    width: 333,
    height: 202,
    rx: 9,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips3);
export default __webpack_public_path__ + "static/media/tips3.8f38a892cc8e87a6a62421027a71f7e5.svg";
export { ForwardRef as ReactComponent };